export default "__VITE_ASSET__BVVHI7T8__"